/**
* Component: purchaseDetailsReducer.js
* Description: This reducer manages the state related to purchase details.
*/

const initialState = {
  isAssetCreation:true,
  warrantyStartDate: "",
  warrantyEndDate: "",
  commissioningDate: "",
  warranty: '',
  purchaseOrderNo: '',
  purchaseCost: '',
  accessories: '',
  cumpartscost: '',
  cumulativeLabourCost: '',
  lastUnscheduledWorkOrder: '',
  lastScheduledWorkOrder: '',
  assetTransferCategory: '',
  purchaseFlag: '',
  assetTransferDepartment: '',
  vendor: '',
  depreciationValue: '',
  underWaranty: '',
  supplier:''
};
    
    const purchaseDetailsReducer = (state = initialState, action) => {
      switch (action.type) {
        case 'UPDATE_PURCHASE_DETAILS':
          return {
            ...state,
            ...action.payload,
          };
          case 'CLEAR_PURCHASE_DETAILS':
            return {};
        default:
          return state;
      }
    };
    
    export default purchaseDetailsReducer;
    